module.exports = __webpack_public_path__ + "media/images/lov_it1-6c4debef5191fc1247b20898c34560a4.jpg";